// Rejection value for modals closed without a result (backdrop click, ✕,
// escape). Named so callers and error monitoring can tell a dismissal apart
// from a real failure.
export default class ModalDismissedError extends Error {
  constructor(message = "Modal dismissed") {
    super(message);
    this.name = "ModalDismissedError";
    this.isModalDismissed = true;
  }
}
